import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `settingsSessions:` scope (F13,
 * `/settings/sessions`) — see `../settings.i18n.ts`'s doc comment for the
 * pattern this follows (`driveSettings:` precedent).
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/settingsSessions.json`.
 */
const en = {
  'page.title': 'Sessions',
  'page.description': 'Devices and browsers currently signed in to your account.',
  'status.loading': 'Loading your sessions…',
  'status.error.title': "Couldn't load your sessions.",
  'status.empty.title': 'No other sessions',
  'status.empty.description': "You're only signed in on this device.",
  'session.current': 'This device',
  'session.lastSeen': 'Last seen {when}',
  'session.created': 'Signed in {when}',
  'action.revoke': 'Revoke',
  'action.revokeAll': 'Revoke all other sessions',
  'action.retry': 'Retry',
  'revoke.confirm.title': 'Revoke session',
  'revoke.confirm.current.description':
    'This is your current session — revoking it will log you out of this device immediately.',
  'revokeAll.confirm.title': 'Revoke all other sessions',
  'revokeAll.confirm.assetName': '{count, plural, one {# other session} other {# other sessions}}',
  'toast.revoked.action': 'Revoked',
  'toast.revokedAll.action': 'Revoked all other sessions',
  'toast.revokeFailed': "Couldn't revoke that session. Try again.",
  'toast.revokeAllFailed': "Couldn't revoke your other sessions. Try again.",
} as const;

const ro: Record<keyof typeof en, string> = {
  'page.title': 'Sesiuni',
  'page.description': 'Dispozitive și browsere autentificate momentan în contul tău.',
  'status.loading': 'Se încarcă sesiunile tale…',
  'status.error.title': 'Nu am putut încărca sesiunile tale.',
  'status.empty.title': 'Nicio altă sesiune',
  'status.empty.description': 'Ești autentificat doar pe acest dispozitiv.',
  'session.current': 'Acest dispozitiv',
  'session.lastSeen': 'Ultima activitate {when}',
  'session.created': 'Autentificat {when}',
  'action.revoke': 'Revocă',
  'action.revokeAll': 'Revocă toate celelalte sesiuni',
  'action.retry': 'Reîncearcă',
  'revoke.confirm.title': 'Revocă sesiunea',
  'revoke.confirm.current.description':
    'Aceasta este sesiunea ta curentă — revocarea ei te va deconecta imediat de pe acest dispozitiv.',
  'revokeAll.confirm.title': 'Revocă toate celelalte sesiuni',
  'revokeAll.confirm.assetName': '{count, plural, one {# altă sesiune} few {# alte sesiuni} other {# de alte sesiuni}}',
  'toast.revoked.action': 'Revocată',
  'toast.revokedAll.action': 'Toate celelalte sesiuni au fost revocate',
  'toast.revokeFailed': 'Nu am putut revoca acea sesiune. Încearcă din nou.',
  'toast.revokeAllFailed': 'Nu am putut revoca celelalte sesiuni. Încearcă din nou.',
};

export const SETTINGS_SESSIONS_CATALOG: Record<Locale, Record<keyof typeof en, string>> = { en, ro };

export type SettingsSessionsCatalogKey = keyof typeof en;
